import { _ep0, _mw0, command } from "../commandBuilder";
import { CreateToken$ } from "../schemas/schemas_0";
export class CreateTokenCommand extends command(_ep0, _mw0, "CreateToken", CreateToken$) {
}
